import { Component, Input } from '@angular/core';
var TeaserBannerComponent = /** @class */ (function () {
    function TeaserBannerComponent() {
        this._searchParamNameDefault = 'query';
    }
    TeaserBannerComponent.prototype.ngOnInit = function () {
        if (this.buttonText) {
            this.updateLinkUrl();
        }
    };
    TeaserBannerComponent.prototype.updateLinkUrl = function () {
        this.updateParamValue();
        // for v1: v1's teaser banner is specific for product
        if (this.searchTxt !== undefined && this.buttonQueryString == undefined) {
            this.buttonHref = this.buttonText.href + '?' + this.searchParamName + '=' + this.searchTxt + ':' + this.sortOrder;
            // for v2
        }
        else if (this.searchTxt !== undefined && this.buttonQueryString != undefined && this.buttonQueryString.indexOf("searchquery") > 0) {
            this.buttonHref = this.buttonText.href.replace("#searchquery#", "") + '?' + this.searchParamName + '=' + this.searchTxt + ':' + this.sortOrder;
        }
        else {
            this.buttonHref = this.buttonText.href;
        }
    };
    TeaserBannerComponent.prototype.updateParamValue = function () {
        this.paramName !== undefined
            ? (this.searchParamName = this.paramName)
            : (this.searchParamName = this.searchParamNameDefault);
    };
    Object.defineProperty(TeaserBannerComponent.prototype, "searchParamNameDefault", {
        get: function () {
            return this._searchParamNameDefault;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TeaserBannerComponent.prototype, "searchParamName", {
        get: function () {
            return this._searchParamName;
        },
        set: function (value) {
            this._searchParamName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TeaserBannerComponent.prototype, "buttonHref", {
        get: function () {
            return this._buttonHref;
        },
        set: function (value) {
            this._buttonHref = value;
        },
        enumerable: true,
        configurable: true
    });
    TeaserBannerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'cov-teaser-banner',
                    template: "<div [ngClass]=\"[backgroundImage && backgroundImage.source ? 'm-teaser-banner' : ('m-teaser-banner m-teaser-banner--' + defaultTheme) ]\">\r\n\r\n\t<cov-image *ngIf=\"backgroundImage && backgroundImage.source\" [image]=\"backgroundImage\"></cov-image>\r\n\t\r\n\t<div class=\"m-teaser-banner__body\">\r\n\t\t<cov-heading *ngIf=\"bannerText\" [level]=\"bannerText && bannerText.level\" [modifier]=\"bannerText && bannerText.modifier\" [text]=\"bannerText && bannerText.text\" [class]=\"bannerText && bannerText.class\"></cov-heading>\r\n\t\t<p class=\"m-teaser-banner__description\" [innerHTML]=\"description\"></p>\r\n\t</div>\r\n\t\r\n\t<div class=\"m-teaser-banner__button\">\r\n\t\t<cov-button *ngIf=\"buttonText\"\r\n\t\t\t[buttonlink]=\"buttonText && buttonText.buttonlink\"\r\n\t\t\t[text]=\"buttonText && buttonText.text\"\r\n\t\t\t[href]=\"buttonHref\"\r\n\t\t\t[modifier]=\"buttonText && buttonText.modifier\"\r\n\t\t\t[class]=\"buttonText && buttonText.class\"\r\n\t\t></cov-button>\r\n\t</div>\r\n</div>\r\n"
                }] }
    ];
    TeaserBannerComponent.propDecorators = {
        searchTxt: [{ type: Input }],
        paramName: [{ type: Input }],
        sortOrder: [{ type: Input }],
        bannerText: [{ type: Input }],
        buttonText: [{ type: Input }],
        description: [{ type: Input }],
        backgroundImage: [{ type: Input }],
        defaultTheme: [{ type: Input }],
        buttonQueryString: [{ type: Input }]
    };
    return TeaserBannerComponent;
}());
export { TeaserBannerComponent };
//# sourceMappingURL=teaser-banner.component.js.map